import { useEffect } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useUserSelector } from '@core/js/store/hooks';
import { fetchLeaderboardsListConfig } from './fetch';
import * as actions from '@theme/js/components/system/App/store/actions';

export const useGetLeaderboardsConfiguration = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect(() => {
        if (isLoggedIn) {
            fetchLeaderboardsListConfig()
                .then((data) => { dispatch(actions.setLeaderboardsConfig(data)); });
        }
    }, [dispatch, isLoggedIn]);
};
